export type CustomerDetailsProcessesTranslation = {
  title: string;
};

export const customerDetailsProcessesTranslation: CustomerDetailsProcessesTranslation = {
  title: 'Procesy',
};
